/* =====================================================================
   Get Fe Leads — homepage design enhancements + subscription button.
   Additive & progressive. Does NOT change any of the site's wording.
   ===================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var APP = 'https://dig-lead-billing.hitesh-c30.workers.dev';
  var PER_LEAD = { 'gold-fe-leads': '$9.75', 'platinum-fe-leads': '$14.75' };
  var SUB_MAP = { 'gold-fe-leads': 'gold', 'platinum-fe-leads': 'platinum' };

  function main() { return document.getElementById('MainContent'); }
  function firstSection() { var m = main(); return m ? m.querySelector(':scope > .shopify-section') : null; }

  // ---- Hero emphasis — style ONLY (no wording changes) ----
  function enhanceHero() {
    var hero = firstSection(); if (!hero) return;
    var nodes = hero.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector && el.querySelector('h1,h2,h3,h4,h5,h6,p')) continue;
      var t = (el.textContent || '').trim(); if (!t) continue;
      if (/Get Insurance Leads FAST/i.test(t) && !el.dataset.feDone) { el.classList.add('fe-hero-h'); el.dataset.feDone = '1'; }
      else if (/Fresh, Real-?Time, Daily Leads/i.test(t) && !el.dataset.feDone) { el.classList.add('fe-hero-sub'); el.dataset.feDone = '1'; }
    }
  }

  // ---- Per-lead badge on Gold & Platinum cards ----
  function addPerLead() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute('href') || '', handle = null;
      Object.keys(PER_LEAD).forEach(function (h) { if (href.indexOf('/products/' + h) !== -1) handle = h; });
      if (!handle) return;
      var card = a.closest('.product-card');
      if (!card || card.querySelector('.fe-perlead')) return;
      var content = card.querySelector('.product-card__content') || card;
      var title = content.querySelector('[class*="product_title" i]') || content.querySelector('[class*="title" i]') || content.querySelector('h2, h3, h4');
      var b = document.createElement('div'); b.className = 'fe-perlead';
      b.innerHTML = '<span class="fe-perlead__amt">' + PER_LEAD[handle] + '</span> <span class="fe-perlead__unit">per lead</span>';
      if (title && title.parentNode) title.parentNode.insertBefore(b, title.nextSibling); else content.appendChild(b);
    });
  }

  // ---- Subscription button on Gold & Platinum PRODUCT pages ----
  function addSubscribeButton() {
    var path = location.pathname, handle = null;
    Object.keys(SUB_MAP).forEach(function (h) { if (path.indexOf('/products/' + h) !== -1) handle = h; });
    if (!handle) return;
    if (document.querySelector('.fe-sub-btn')) return;
    var buy = document.querySelector('.buy-buttons-block');
    if (!buy || !buy.parentNode) return;
    // Subscription button (primary CTA) — placed ABOVE Add to cart
    var wrap = document.createElement('div');
    wrap.className = 'fe-sub-btn';
    wrap.setAttribute('style', 'margin:0 0 10px;');
    var a = document.createElement('a');
    a.href = APP + '/subscribe?product=' + SUB_MAP[handle];
    a.textContent = 'Start 4-week subscription — pay 50% now';
    a.setAttribute('style', 'display:block;text-align:center;text-decoration:none;background:#12365f;color:#fff;font-weight:700;padding:15px 16px;border-radius:10px;');
    var note = document.createElement('div');
    note.setAttribute('style', 'text-align:center;font-size:.8rem;color:#666;margin-top:6px;');
    note.textContent = '4 weekly batches · 50% now, 50% in 14 days · cancel anytime';
    wrap.appendChild(a); wrap.appendChild(note);
    // One-time purchase caption — placed just above the Add to cart button (which stays below)
    var cap = document.createElement('div');
    cap.className = 'fe-onetime-cap';
    cap.setAttribute('style', 'text-align:center;font-size:.85rem;color:#12365f;font-weight:600;margin:4px 0 8px;');
    cap.innerHTML = '— or click <b>Add to cart</b> below for a one-time purchase —';
    buy.parentNode.insertBefore(wrap, buy);
    buy.parentNode.insertBefore(cap, buy);
  }

  // ---- Reveal-on-scroll for homepage sections ----
  function addReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var targets = [], m = main();
    if (m) m.querySelectorAll(':scope > .shopify-section').forEach(function (el, i) { if (i !== 0) targets.push(el); });
    if (!targets.length) return;
    targets.forEach(function (el) { el.classList.add('fe-reveal-init'); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fe-in'); io.unobserve(e.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
    setTimeout(function () { targets.forEach(function (el) { el.classList.add('fe-in'); }); }, 2500);
  }

  function run() {
    try { enhanceHero(); } catch (e) {}
    try { addPerLead(); } catch (e) {}
    try { addSubscribeButton(); } catch (e) {}
    try { addReveal(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () {
    try { addPerLead(); } catch (e) {}
    try { addSubscribeButton(); } catch (e) {}
  });
})();
